import React from 'react';
import { Link } from 'react-router-dom';
import { portfolioItems } from '../data/portfolioData';
import SEO from '../components/SEO';

const Works = () => {
  return (
    <>
      <SEO 
        title="Portfolio Works | Franklin Fernandez"
        description="Explore Franklin's portfolio of web development and design projects showcasing UI/UX expertise."
        keywords="portfolio, works, web design, UI/UX, projects, case studies"
      />
    <main>
      <section id="home" className="breadcrumb-section">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <div className="content w-60">
                <h1 className="title">Showcasing innovation</h1>
                <div className="flex ms-auto"><span className="line animate-line"></span>
                  <h1 className="title">and expertise</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="works explore-area portfolio-filter pt-0">
        <div className="container p-0">
          <div className="row filter-items items inner">
            {portfolioItems.map((item, index) => (
              <div key={index} className="col-12 col-lg-4 item filter-item">
                <div className="card portfolio-item layout-2 scale has-shadow">
                  <div className="image-holder">
                    <Link className="card-thumb" to={`/portfolio/${item.slug}`}>
                      <img loading="lazy" alt={item.title} src={item.image} />
                    </Link>
                  </div>
                  <div className="card-content p-2">
                    <div className="heading">
                      <h4 className="title mt-2 mt-md-3 mb-3">{item.title}</h4>
                      <div className="show-project">
                        <div className="card-terms">
                          {item.tags.map((tag, tagIndex) => (
                            <span key={tagIndex} className="badge text-bg-light">{tag}</span>
                          ))}
                        </div>
                        <div className="project-link">
                          <Link className="text-decoration-none" to={`/portfolio/${item.slug}`}>Show Project</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <section className="cta layout-2 primary-bg">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-md-8 col-lg-7">
              <div className="cta-text"><span className="sub-title">Want to collaborate?</span>
                <h2 className="title mt-3 mb-0">Let's Create Something <span className="text-secondary">Together</span></h2>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-5 text-md-end mt-3 mt-md-0 d-flex justify-content-end align-items-center">
              <a href="mailto:fernandez954@gmail.com" className="btn btn-dark">Get In Touch!
                <i className="icon bi bi-arrow-right ms-1"></i>
                <span></span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
}

export default Works;